export const PAGE_SIZE = 30;

export const MAX_PAGES_MEMORY = 3;

export const REST_TIMER = 300;